export default __webpack_public_path__ + "static/media/banner6.3418535f.png";